import { Trash2 } from "lucide-react";
import { type ChangeEvent, useEffect, useState } from "react";

import { Input } from "@/app/components/ui/input";
import { Label } from "@/app/components/ui/label";
import type { PersonalLink } from "@/app/types/resume";

interface LinkInputProps {
	data: PersonalLink;
	setData: (index: number, data: PersonalLink) => void;
	linkOptions: string[];
	deleteLink: () => void;
	index: number;
	error?: string;
}

function LinkInput({ setData, data, linkOptions, deleteLink, index, error }: LinkInputProps) {
	const [link, setLink] = useState<PersonalLink>({
		type: "",
		value: "",
	});

	useEffect(() => {
		if (data) {
			setLink(data);
		}
	}, [data]);

	const onChangeType = (e: ChangeEvent<HTMLSelectElement>) => {
		setLink({
			...link,
			type: e.target.value,
		});
	};

	const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
		setLink({
			...link,
			value: e.target.value,
		});
	};

	useEffect(() => {
		setData(index, link);
	}, [link]);

	return (
		<div className="mb-3 grid grid-cols-3 gap-2">
			<div className="space-y-1">
				<Label htmlFor={`linkType-${index}`} className="text-sm">
					Link Type
				</Label>
				<select
					className="flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm transition-colors focus-visible:outline-hidden"
					value={link.type}
					onChange={onChangeType}
					id={`linkType-${index}`}
				>
					<option value="">Select Link Type</option>
					{linkOptions.map((option) => (
						<option key={option} value={option}>
							{option}
						</option>
					))}
				</select>
			</div>
			<div className="col-span-2 space-y-1">
				<Label htmlFor={`linkInput-${index}`} className="text-sm">
					Link URL
				</Label>

				<div className="flex items-center gap-2">
					<Input
						type="url"
						id={`linkInput-${index}`}
						value={link.value}
						onChange={onChangeInput}
						placeholder="Enter Url"
					/>
					{link.value.length > 0 && (
						<button
							type="button"
							onClick={deleteLink}
							className="cursor-pointer text-error-default hover:text-error-dark"
							aria-label="Delete link"
						>
							<Trash2 className="size-4" />
						</button>
					)}
				</div>
			</div>
			{error && <p className="col-span-3 text-error-default text-sm">{error}</p>}
		</div>
	);
}

export default LinkInput;
